module.exports = __webpack_public_path__ + "img/buildicon.7acb7312.png";